<template>
    <v-dialog :disabled="disabled" persistent v-model="dialog" width="50%">
        <template v-slot:activator="{ on: dialog, attrs }">
            <v-btn v-bind="attrs" v-on="{ ...dialog }" :disabled="disabled" id="open-thumbnail-modal" color="primary" e2e-space-upload>
                <v-icon left>mdi-upload</v-icon>
                Upload
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="flex-nowrap align-start">
                File upload
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <v-tabs v-model="tab">
                    <v-tab>Local device</v-tab>
                    <v-tab>Web Address (URL)</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <uppy-upload :endpoint="endpoint" @uploading="uploading" :reset="dialog" />
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <url-upload @uploading="uploading" :reset="dialog"></url-upload>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-card-actions v-if="isUploadSuccess">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="ok()" :disabled="isUploading">Ok</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import eventBus from '@/components/EventBus'
const UppyUpload = () => import('@/components/UppyUpload.vue')
const UrlUpload = () => import('@/components/UrlUpload.vue')

export default {
    name: 'FileUpload',
    components: {
        UppyUpload,
        UrlUpload
    },
    props: {
        endpoint: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialog: false,
            tab: null,
            loading: ''
        }
    },
    created() {
        eventBus.$on('openFileUploadDialog', evt => {
            this.dialog = true
        })
    },
    computed: {
        isUploading() {
            return this.loading === 'uploading'
        },
        isUploadError() {
            return this.loading === 'error'
        },
        isUploadSuccess() {
            return this.loading === 'success'
        }
    },
    methods: {
        uploading(value) {
            // value can be 'uploading', 'error', 'success'
            this.loading = value
        },
        ok() {
            this.$store.dispatch('snapshotStore/fetchCurrentFiles', { id: this.$route.params.snid, route: this.$route, setFetchingStatus: true })
            this.dialog = false
        }
    }
}
</script>
